export const sanitizeErrorForRedux = (error) => ({
    name: error.name || 'UnknownError',
    code: error.code || 'ERR_UNKNOWN',
    message: error.message || 'An unexpected error occurred',
    details: error.details || {}, // Assumes details is already serializable
    timestamp: new Date().toISOString(),
    isNew: true,
});
